import { Direction } from '../../../shared/types/enums'
import type { Journey } from '../../../shared/types'

/**
 * Clé route stable `ORIGIN-DEST` (codes ports) dérivée du catalogue de la
 * recherche en cours. Source unique réutilisée par tous les jalons funnel.
 */
export function routeKey(journeys: Journey[]): string {
  const primary = journeys.find((j) => j.direction === Direction.Outward) ?? journeys[0]
  if (!primary) return ''
  return `${primary.origin?.port_code ?? ''}-${primary.destination?.port_code ?? ''}`
}
